function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M293.8,125h-65c-3,0-5.5,2.4-5.5,5.5c0,3,2.4,5.4,5.4,5.5v16 c0,3,2.4,5.5,5.5,5.5h11l0,34.2h-11c-3,0-5.5,2.4-5.5,5.5c0,3,2.4,5.5,5.5,5.5h54.3c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9 c0-3-2.4-5.5-5.5-5.5h-11l0-34.2h11c1.5,0,2.9-0.6,3.9-1.6s1.6-2.4,1.6-3.9v-16c1.5,0,2.8-0.6,3.8-1.6c1-1,1.6-2.4,1.6-3.9 C299.3,127.5,296.9,125,293.8,125z M266.6,191.7h-10.5l0-34.2h10.5L266.6,191.7z M283,146.5h-43.4l0-10.5H283V146.5z"
}), React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M234.2,256l-17.2,0c-3,0-5.5,2.4-5.5,5.5v51.9 c0,1.4,0.6,2.8,1.6,3.9c1,1,2.4,1.6,3.9,1.6h11.7v40.9h-5.3c-1.4,0-2.8,0.6-3.9,1.6c-1,1-1.6,2.4-1.6,3.9l0,29.7 c0,3,2.4,5.5,5.5,5.5h5.3l0,10.6c0,3,2.4,5.5,5.5,5.5h54.3c1.4,0,2.8-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9v-10.6h5.3 c1.5,0,2.9-0.6,3.9-1.6s1.6-2.4,1.6-3.9v-29.7c0-3-2.4-5.5-5.5-5.5l-5.3,0l0-98.3c0-1.4-0.6-2.8-1.6-3.9c-1-1-2.4-1.6-3.9-1.6 L234.2,256z M222.5,307.9V267l6.2,0v40.9L222.5,307.9z M268.5,370.7v18.7l-14.3,0l0-18.7H268.5z M228.9,370.7l14.3,0l0,18.7l-9.1,0 c0,0,0,0,0,0s0,0,0,0l-5.3,0L228.9,370.7z M283,405.5l-43.4,0v-5.2H283L283,405.5z M293.7,389.4l-14.3,0v-18.7l14.3,0L293.7,389.4z  M283,359.7H274c0,0,0,0,0,0c0,0,0,0,0,0l-25.3,0c0,0,0,0,0,0c0,0,0,0,0,0h-9.1v-46.4c0,0,0,0,0,0c0,0,0,0,0,0V267l43.4,0 L283,359.7z"
}), React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M234.2,239.9c-3,0-5.5,2.4-5.5,5.5c0,3,2.4,5.5,5.5,5.5 l54.3,0c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9c0-3-2.4-5.5-5.5-5.5L234.2,239.9z"
}), React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M234.2,223.8c-3,0-5.5,2.4-5.5,5.5c0,3,2.4,5.5,5.5,5.5h54.3 c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9c0-3-2.4-5.5-5.5-5.5L234.2,223.8z"
}), React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  d: "M234.2,207.7c-3,0-5.5,2.4-5.5,5.5c0,3,2.4,5.5,5.5,5.5h54.3 c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9c0-3-2.4-5.5-5.5-5.5L234.2,207.7z"
}));

var SvgLasersword = function SvgLasersword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLasersword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lasersword.6cefb9f8.svg";
export { ForwardRef as ReactComponent };